/**
 * cloudinary.js — Cloudinary URL transformation helpers
 *
 * Inserts Cloudinary image transformations into a stored secure_url.
 * Works only with Cloudinary URLs (res.cloudinary.com).
 * Falls back to the original URL for non-Cloudinary sources (e.g. OAuth avatars).
 *
 * Usage:
 *   import { cloudinaryAvatar } from '../utils/cloudinary';
 *   <img src={cloudinaryAvatar(user.avatar_url, 64)} />
 */

/**
 * Build a Cloudinary transform string and inject it into the URL.
 * @param {string} url - Cloudinary secure_url stored in MongoDB
 * @param {number} size - Target width and height in pixels
 * @returns {string} Transformed URL
 */
export function cloudinaryAvatar(url, size) {
  if (!url || !url.includes('res.cloudinary.com')) return url;
  // Insert after /upload/ — e.g.
  // https://res.cloudinary.com/cloud/image/upload/v123/avatars/VW-XXX.jpg
  // → https://res.cloudinary.com/cloud/image/upload/c_fill,w_64,h_64,f_auto,q_auto/v123/avatars/VW-XXX.jpg
  const transform = `c_fill,w_${size},h_${size},f_auto,q_auto`;
  return url.replace('/upload/', `/upload/${transform}/`);
}
